<template>
  <div>
    <SameQuestionAnswerGuide />
    <SameQuestionGuide />
    <AnswerWrongBookEntryGuide />
  </div>
</template>

<script>
/*
 * By Suxue
 * 2021/8/31
 */
import SameQuestionAnswerGuide from './components/SameQuestionAnswerGuide'
import SameQuestionGuide from '@/pages/answer/popups/components/SameQuestionGuide'
import AnswerWrongBookEntryGuide from '@/pages/answer/popups/components/AnswerWrongBookEntryGuide'
export default {
  components: {
    AnswerWrongBookEntryGuide,
    SameQuestionAnswerGuide,
    SameQuestionGuide
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped></style>
